import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);

VTooltip.options.defaultTrigger = "click hover focus";

export default VTooltip;
